import {AbstractControl} from '@angular/forms';

type ValidationErrorKeyValueMap = { [key: string]: any } | null;

export class CustomValidator {
  // Number only validation
  static numeric(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {
      return {invalidNumber: true};
    }
    return null;
  }

  // Check if it is Whole number No Decimal point
  static wholeNumber(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(/^\d+$/)) {
      return {invalidWholeNumber: true};
    }
    return null;
  }

  static validNumber(control: AbstractControl): ValidationErrorKeyValueMap | null {
    const value = control?.value;
    if (!value) {
      return null;
    }
    if (isNaN(value)) {
      return {invalidNumber: true};
    }
    return null;
  }

  static email(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    const EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(EMAIL_REGEX)) {
      return {invalidEmail: true};
    }
    return null;
  }

  static twoDecimalPlace(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    const regexp = /^[0-9]*(\.[0-9]{0,2})?$/;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(regexp)) {
      return {invalidNumber: true};
    }
    return null;
  }

  static mobileNumberValidator(control: AbstractControl): ValidationErrorKeyValueMap {
    const mobileNumber = control?.value;
    const regex = /^0[0-9]{9}$/;
    if (!mobileNumber || mobileNumber === '') {
      return null;
    }

    if (!regex.test(mobileNumber)) {
      return {invalidMobileNumber: true};
    }

    return null;
  }

  static atLeastOneValue(control: AbstractControl): ValidationErrorKeyValueMap {
    if (!control || !control.value) {
      return null;
    }
    const hasAtleastOneValue = Object.values(control.value)?.length > 0;
    if (!hasAtleastOneValue) {
      return {atleastOneValue: true};
    }
    return null;
  }

  /**
   * South African Branch Code 6 Digits validator
   * This ensures that the input strictly adheres to the 6-digit numeric format allowing leading zeros.
   */
  static SABranchCodeValidator(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '') {
      return null;
    }
    if (!/^\d{6}$/.test(val.toString())) {
      return {branchCodeNumeric: true};
    }
    return null;
  }

  /**
   * Id Validation
   */

  static idNumberNumeric(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {
      return {idNumberNumeric: true};
    }
    return null;
  }

  // length validation
  static idNumberLength(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '') {
      return null;
    }
    if (!val.toString().match(/^.{13}$/)) {
      return {idNumberLength: true};
    }
    return null;
  }

  static idNumberDOB(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val.length < 13) {
      return null;
    }

    const datePart = val.substring(0, 6);

    const year = parseInt(datePart.substring(0, 2), 10);
    const month = parseInt(datePart.substring(2, 4), 10);
    const day = parseInt(datePart.substring(4, 6), 10);

    const fullYear = year < 50 ? 2000 + year : 1900 + year;
    const date = new Date(fullYear, month - 1, day);

    if (
      date.getFullYear() !== fullYear ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return {idNumberDOB: true};
    }


    return null;
  }

  static idLuhnValidation(control: AbstractControl): ValidationErrorKeyValueMap {
    const val = control?.value;
    if (!val || val === '' || !val.toString().match(/^.{13}$/)) {
      return null;
    }
    if (!isLuhnValid(val)) {
      return {idNumberLuhn: true};
    }
    return null;
  }
}

function isLuhnValid(idNumber: string): boolean {
  let sum = 0;
  const reverseDigits = idNumber.split('').reverse();

  for (let i = 0; i < reverseDigits.length; i++) {
    let digit = parseInt(reverseDigits[i], 10);

    // Double every second digit
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9; // Subtract 9 if the result is greater than 9
      }
    }

    // Add digit to the sum
    sum += digit;
  }

  // Valid if the sum modulo 10 is 0
  return sum % 10 === 0;
}

